import React from "react";
import { DefaultOverview, DefaultTopics } from "./DefaultViews";
export const CommonConfigurationTestPermissionOverview = () => {
    return <DefaultOverview />;
};
export const CommonConfigurationTestPermissionTopics = () => {
    return <DefaultTopics />;
};
